export default {"src":"/_next/static/media/favicon_32x32.979f0454.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};